const isIndividualEntity = (entity) => entity && entity.isIndividual;

export default isIndividualEntity;
